import React, { useEffect, useState } from "react";
import { FC, InputHTMLAttributes, MutableRefObject } from "react";

import { Input } from "./styled";
import ClearMask from "./ClearMask";

interface IInputCurrentBRL extends InputHTMLAttributes<HTMLInputElement> {
  err: boolean;
  ref?: MutableRefObject<HTMLInputElement | null>;
  onInputChange: (value: string) => void;
}

const InputCurrentBRL: FC<IInputCurrentBRL> = ({
  onInputChange,
  err,
  defaultValue,
  ...rest
}) => {
  const [value, setValue] = useState({ default: "", current: "" });

  function convert(number: number) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    })
      .format(number)
      .replace(",00", "");
  }

  useEffect(() => {
    if (defaultValue) {
      const defaultInput = convert(parseFloat(defaultValue as string) || 0.0);
      setValue({ current: defaultInput, default: defaultInput });
    }
  }, [defaultValue]);
  const ConvertToMoney = (coin: string) => {
    const numberFloatDecimal = coin.split(",")[1];

    if (numberFloatDecimal?.length <= 1) {
      setValue({
        current: coin,
        default: coin,
      });
      return;
    }

    const clear = ClearMask(coin);

    const found = coin.match(/,/g);
    if (found && found?.length > 1) return;
    const money = convert(parseFloat(clear));

    const lastCharset = clear.split("")[clear.length - 1];
    if (lastCharset === "." && clear.length >= 3) {
      const newCoin = coin.split("").slice(coin.length);
      setValue({
        current: parseFloat(clear) ? money : coin,
        default: coin,
      });
      return;
    }
    setValue({
      current: parseFloat(clear) ? money : coin,
      default: parseFloat(clear) ? money : coin,
    });
  };

  function reactiveInput() {
    setValue((old) => {
      onInputChange(ClearMask(old.current));
      return { default: old.current, current: old.default };
    });
  }
  return (
    <Input
      {...rest}
      err={err}
      value={value.default}
      onChange={(e) => ConvertToMoney(e.target.value)}
      onFocus={() => reactiveInput()}
      onBlur={() => reactiveInput()}
    />
  );
};

export default InputCurrentBRL;
